/**
 * T30.1 · O texto alternativo do desenho é a CENA EM PORTUGUÊS. Era o pedido em inglês mandado ao
 * desenhista («watercolor children's book character… safe for children»), e o relatório de 19/10
 * o leu por cima dos quadros vazios depois do recarregar.
 */
export function descricaoDoQuadro(p: { prompt: string; cena?: string }): string {
  const cena = (p.cena ?? "").replace(/^[^:]{1,40}:\s*/, "").trim();
  return cena || "Desenho do quadro";
}
